import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=06cea2de&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cea2de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cea2de')) {
      api.createRecord('06cea2de', component.options)
    } else {
      api.reload('06cea2de', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=06cea2de&scoped=true&", function () {
      api.rerender('06cea2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cdLaVl8G5woD/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports